import { render, staticRenderFns } from "./CampaignAlert.vue?vue&type=template&id=ae5a2322&scoped=true&"
import script from "./CampaignAlert.vue?vue&type=script&lang=js&"
export * from "./CampaignAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5a2322",
  null
  
)

export default component.exports